import React from 'react';
import PropTypes from 'prop-types';
import { Conversation } from './Conversation';

export const ConversationList = (props) => {

	const { conversations } = props;

	return (
		<div className="row padding-half-x padding-half-bottom">
			{
				conversations && conversations.length > 0 && conversations.map((conversation, index) => <Conversation key={index} conversation={conversation} />)
			}
		</div>
	);
};

ConversationList.propTypes = {
	conversations: PropTypes.array
}



// WEBPACK FOOTER //
// src/client/components/site/features/networking/pages/elements/ConversationList.js